module.exports = __webpack_public_path__ + "assets/img/4.a991118f.svg";